export default (subscription) => {
  if (subscription === 'POSTPAID') return 'Pay Monthly';
  if (subscription === 'PREPAID') return 'Pay As You Go';

  return null;
};
